import { yupResolver } from '@hookform/resolvers/yup';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import detectorActivityFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/detector/meta/DetectorActivityFormMeta';
import { IDetectorsFormMeta } from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/detector/meta/DetectorsFormMeta';
import othersFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/detector/meta/OthersFormMeta';
import partsDistributorFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/detector/meta/PartsDistributorFormMeta';
import tapesFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/detector/meta/TapesFormMeta';

import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  meta: IDetectorsFormMeta,
} & TFormUIProps;

const DetectorsFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CC.Box>
        {displayCustomInputs<IDetectorsFormMeta>(
          meta,
          register,
          errors,
          isLoading,
          [meta.lastUpdateDate.name],
          []
        )}
      </CC.Box>
      <CC.SimpleGrid
        columns={{ base: 1, lg: 2 }}
        gridRowGap={4}
        columnGap={10}
        my={4}
      >
        <CustomFieldSet title="Activité Détecteurs">
          <CC.SimpleGrid
            columns={{ base: 1, lg: 2 }}
            gridRowGap={4}
            columnGap={10}
            my={4}
          >
            {displayCustomInputs<IDetectorsFormMeta>(
              detectorActivityFormMeta,
              register,
              errors,
              isLoading,
              [],
              []
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title="Cassettes">
          <CC.SimpleGrid
            columns={{ base: 1, lg: 2 }}
            gridRowGap={4}
            columnGap={10}
            my={4}
          >
            {displayCustomInputs<IDetectorsFormMeta>(
              tapesFormMeta,
              register,
              errors,
              isLoading,
              [],
              []
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title="Distributeur de Pièces">
          <CC.SimpleGrid
            columns={{ base: 1, lg: 2 }}
            gridRowGap={4}
            columnGap={10}
            my={4}
          >
            {displayCustomInputs<IDetectorsFormMeta>(
              partsDistributorFormMeta,
              register,
              errors,
              isLoading,
              [],
              []
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title="Autres">
          <CC.SimpleGrid
            columns={{ base: 1, lg: 2 }}
            gridRowGap={4}
            columnGap={10}
            my={4}
          >
            {displayCustomInputs<IDetectorsFormMeta>(
              othersFormMeta,
              register,
              errors,
              isLoading,
              [],
              []
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>
      </CC.SimpleGrid>

      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default DetectorsFormUI;
